import { render } from "./TopAnimation.vue?vue&type=template&id=1c384434&scoped=true"
import script from "./TopAnimation.vue?vue&type=script&lang=js"
export * from "./TopAnimation.vue?vue&type=script&lang=js"

import "./TopAnimation.vue?vue&type=style&index=0&id=1c384434&scoped=true&lang=css"

import exportComponent from "c:\\Qedtek Project\\Takayama-New\\takayama_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c384434"]])

export default __exports__